import React, { Component } from 'react';

class IconArrowLeft extends Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="9.771" height="14.454" viewBox="0 0 9.771 14.454"><path className="a" d="M1811.182,4362.342l-7.567,6.731,7.567,6.2" transform="translate(-1802.076 -4361.595)" fill="none" stroke="#808495" strokeWidth="2px" /></svg>
        );
    }
}

export default IconArrowLeft;